import Vue from 'vue';

const files = require.context('.', false, /\.vue$/);
const importFn = require.context('./', false, /\.vue$/)

files.keys().forEach(path => {
    const component = importFn(path).default;
    Vue.component(component.name, component)
})


// WEBPACK FOOTER //
// ./src/components/common/index.js